var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgS(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 44,
    viewBox: "0 0 33 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 33.662V15.3105L18.9538 25.6488V44.0003L0 33.662Z",
    fill: "url(#paint0_linear_2934_5856)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9999 36.5261V18.1748L18.9538 25.6482V43.9995L32.9999 36.5261Z",
    fill: "url(#paint1_linear_2934_5856)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.3099L14.0462 7.83643L33 18.1747L18.9538 25.6481L0 15.3099Z",
    fill: "url(#paint2_linear_2934_5856)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29299 25.9385L7.23529 26.3121V26.8519L8.46221 26.3952V28.9694L8.84298 29.2185V26.6858L10.0699 28.6372V28.0975L9.01221 26.4367L8.29299 25.9385Z",
    fill: "#36A94C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8425 34.7411L20.6887 35.3639L21.154 35.1148L20.1386 34.4505L22.2963 33.371V32.9973L20.1386 34.0768L21.154 32.3745L20.6887 32.6236L19.8002 34.0768L19.8425 34.7411Z",
    fill: "#36A94C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2814 27.4333L31.4776 26.8105L31.0545 27.0181L31.9853 27.724L30.0814 28.6789V29.0111L31.9853 28.0561L31.0545 29.6754L31.4776 29.4678L32.2391 28.0561L32.2814 27.4333Z",
    fill: "#36A94C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87049 32.8723L6.34741 32.0419V31.8343L7.15125 31.4192C7.23587 31.3776 7.32048 31.2946 7.4051 31.2531C7.44741 31.2116 7.48972 31.1285 7.48972 31.0455C7.48972 30.9209 7.4474 30.7964 7.36279 30.7133C7.27817 30.5888 7.19357 30.5057 7.06665 30.4227C7.02434 30.3812 6.98202 30.3812 6.8974 30.3397C6.8551 30.3397 6.77048 30.3397 6.72818 30.3397C6.64356 30.3812 6.60126 30.4642 6.60126 30.5888L6.34741 30.4642C6.34741 30.2568 6.43203 30.1322 6.55895 30.0907C6.64356 30.0492 6.77049 30.0492 6.85511 30.0907C6.93972 30.0907 7.02433 30.1322 7.10894 30.2153C7.32048 30.3397 7.48972 30.4642 7.61664 30.6718C7.74356 30.8379 7.78587 31.004 7.78587 31.2116C7.78587 31.4192 7.65894 31.6267 7.36279 31.7513L6.72818 32.0835L7.87049 32.7478V32.8723Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3386 33.7452C11.3809 33.9528 11.2963 34.2019 11.1694 34.3679C11.0424 34.451 10.8732 34.451 10.6194 34.2849C10.4078 34.1603 10.1963 33.9528 10.0694 33.7452C9.94245 33.496 9.90015 33.2054 9.90015 32.9148V32.5411C9.90015 32.2089 9.94245 32.0014 10.0694 31.9183C10.1963 31.8353 10.3655 31.8353 10.6194 32.0014C10.8309 32.1259 11.0424 32.292 11.1694 32.5411C11.2963 32.7902 11.3386 33.0809 11.3386 33.3715V33.7452ZM11.0425 33.2054C11.0425 32.9978 11.0001 32.7902 10.9155 32.6241C10.8309 32.4581 10.7463 32.3335 10.5771 32.292C10.4078 32.2089 10.3232 32.2089 10.2386 32.292C10.154 32.4165 10.1117 32.5826 10.154 32.7487V33.1639C10.154 33.3715 10.1963 33.5791 10.2809 33.7452C10.3655 33.9112 10.4501 34.0358 10.6194 34.1188C10.7463 34.2019 10.8732 34.2019 10.9578 34.1188C11.0424 33.9943 11.0848 33.8282 11.0848 33.6621L11.0425 33.2054Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9613 33.3293L23.0998 34.2843V34.0352L24.0729 32.4989C24.1998 32.3329 24.2844 32.1668 24.369 31.9592C24.4113 31.8346 24.4536 31.7516 24.4536 31.627C24.4536 31.5855 24.4536 31.5025 24.4113 31.461C24.369 31.4194 24.369 31.3779 24.2844 31.3364C24.2421 31.3364 24.1575 31.2949 24.1152 31.3364C24.0728 31.3364 23.9882 31.3779 23.9459 31.4194C23.7767 31.5025 23.6498 31.627 23.5228 31.7931C23.4382 31.9177 23.3536 32.0838 23.3536 32.2913L22.9728 32.4989C22.9728 32.2498 23.0575 32.0007 23.2267 31.7931C23.3959 31.544 23.6498 31.3364 23.9036 31.2119C23.9882 31.1288 24.1152 31.0873 24.1998 31.0873C24.3267 31.0458 24.4113 31.0458 24.5382 31.0873C24.7075 31.1288 24.7498 31.2534 24.7498 31.5025C24.6652 31.9592 24.4959 32.3744 24.1998 32.7065L23.4382 33.8691L24.8767 33.1217L24.9613 33.3293Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4041 29.8831C29.4041 30.2152 29.3618 30.5888 29.1925 30.8794C29.0233 31.1701 28.8118 31.3777 28.5156 31.5022C28.2195 31.6683 27.9656 31.6683 27.8387 31.5853C27.7541 31.5022 27.6694 31.3777 27.6271 31.2531C27.5848 31.1285 27.5848 31.004 27.5848 30.8794V30.4227C27.5848 30.0907 27.6695 29.7585 27.7964 29.4264C27.9656 29.1358 28.1771 28.9282 28.4733 28.8036C28.8118 28.6375 29.0233 28.6375 29.1502 28.7206C29.2772 28.8451 29.3618 29.0942 29.3618 29.4679L29.4041 29.8831ZM29.0656 29.5925C29.1079 29.3849 29.0656 29.1773 28.9387 29.0112C28.8541 28.9282 28.7272 28.9282 28.5156 29.0112C28.3464 29.0942 28.1772 29.2603 28.0925 29.4264C28.0079 29.634 27.9656 29.8831 27.9656 30.0907V30.6718C27.9233 30.8794 28.0079 31.087 28.0925 31.2531C28.1772 31.3361 28.3041 31.3361 28.5156 31.2531C28.6848 31.1701 28.8118 31.004 28.8964 30.8379C28.981 30.6303 29.0233 30.3812 29.0233 30.1737V29.5925H29.0656Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9468 19.7524C12.7776 19.6694 12.1852 19.5864 11.8891 19.5864C11.5083 19.5448 11.2545 19.5033 11.0006 19.4618C10.1122 19.1712 9.30833 18.5484 8.67372 17.5519C7.44679 15.7666 8.25064 13.0263 8.84294 11.5732C9.35064 10.3276 9.77372 9.04051 10.1968 7.79493C10.493 6.92303 10.7891 6.00961 11.1276 5.09619L12.566 5.59442C12.2699 6.46632 11.9314 7.37974 11.6353 8.25164C11.2122 9.53874 10.7468 10.8673 10.2391 12.1129C9.85834 13.0679 9.05448 15.4344 9.90064 16.7631C10.2391 17.2613 10.7468 17.8426 11.4237 18.0502C11.5083 18.0917 11.8045 18.0917 11.9737 18.1332C12.9468 18.2162 13.7929 18.3408 14.0891 18.9636L12.6929 19.5448C12.8199 19.6694 12.9468 19.7524 12.9468 19.7524Z",
    fill: "#494855"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2543 4.59801L14.1736 19.877L14.4274 21.0396L21.4928 17.1368L22.5505 16.5555C22.762 16.431 22.8889 16.1818 22.8889 15.8082V5.80206C22.8889 3.97522 22.5082 2.1899 21.3236 0.985843C21.239 0.902805 21.1543 0.819767 21.0697 0.736729C20.8159 0.529134 20.562 0.363057 20.3082 0.19698L20.2659 0.155461C19.9697 -0.0106154 19.6313 -0.052134 19.4197 0.0724233C19.2928 0.0724233 11.2543 4.59801 11.2543 4.59801Z",
    fill: "url(#paint3_linear_2934_5856)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1725 19.8766L14.3841 21.0392L21.4495 17.1364V10.0781L14.7225 13.8564L14.1725 19.8766Z",
    fill: "url(#paint4_linear_2934_5856)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0346 18.8397L16.0769 11.0341C16.0769 10.4943 16.5 9.78849 16.9654 9.49786L21.1115 7.17279C21.3654 7.00671 21.6192 7.00671 21.7884 7.13127L23.4385 8.08621L22 11.4077V15.5181C22 16.0579 21.5769 16.7637 21.1115 17.0543L18.9961 18.1754L18.023 20.4174L16.2884 19.4209C16.1192 19.3379 16.0346 19.1718 16.0346 18.8397Z",
    fill: "#ECF4EE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7699 12.03V19.8771C17.7699 20.1262 17.8545 20.3338 18.0237 20.4169C18.193 20.5414 18.4468 20.5414 18.7007 20.3753L22.8045 18.0503C23.2699 17.8012 23.693 17.0953 23.693 16.5556V8.66695C23.693 8.37631 23.6083 8.16872 23.3968 8.08568C23.2276 8.00264 23.016 8.04416 22.7622 8.16872L18.6583 10.4938C18.193 10.7844 17.7699 11.4487 17.7699 12.03Z",
    fill: "url(#paint5_linear_2934_5856)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6578 13.732V14.1057L22.0002 12.2373L23.6925 11.2824V10.8672L22.0002 11.8636L18.6578 13.732Z",
    fill: "#494855"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9807 14.6034L18.5307 14.2713V13.5654L17.9807 13.8561V14.6034Z",
    fill: "#494855"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9807 15.8502L18.5307 15.518L18.3615 14.3555L18.1076 14.5215L17.9807 15.8502Z",
    fill: "#494855"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1575 10.5355L12.6075 10.2449V9.49756L13.1575 9.78819V10.5355Z",
    fill: "#494855"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1575 11.8228L12.6075 11.4907L12.7767 10.3281L13.0306 10.4942L13.1575 11.8228Z",
    fill: "#494855"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7342 5.09632V9.45583L13.0727 9.66343V5.42848L21.238 0.985931C21.1534 0.902893 21.0688 0.819855 20.9842 0.736816L12.7342 5.09632Z",
    fill: "#494855"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8306 11.5318V5.34546C10.8306 4.59811 11.3806 4.30748 12.0152 4.68115L12.0575 4.72267C14.0883 5.84369 14.6806 8.0442 14.6806 10.3278V13.8569V13.8984V20.3339C14.6806 21.0812 14.1729 21.4134 13.496 20.9982L12.0152 20.1678C11.3806 19.7941 10.8306 18.8807 10.8306 18.1333V11.5318Z",
    fill: "url(#paint6_linear_2934_5856)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5998 0.820312L17.9806 1.11095L18.0229 1.31854L17.4729 1.02791L17.5998 0.820312Z",
    fill: "#683C11"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3006 2.77187C14.9775 1.06958 16.7544 0.0731252 17.4314 1.02806C17.516 1.1111 17.6429 1.15262 17.7275 1.06958C17.8121 0.986545 17.8544 0.737431 17.7698 0.612873C16.9237 -0.549661 14.8083 0.654392 13.9621 2.77187C13.8775 2.97946 13.8775 3.18706 14.0044 3.18706C14.089 3.14554 14.216 2.97946 14.3006 2.77187Z",
    fill: "#494855"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3886 0.238281L17.981 0.570434L15.7387 1.23474L14.4694 3.39373L13.9617 3.14462L15.3579 0.861068L17.3886 0.238281Z",
    fill: "#494855"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8076 3.02109C15.4846 1.31881 17.2615 0.322349 17.9384 1.27729C18.023 1.36033 18.1499 1.40185 18.2346 1.31881C18.3192 1.23577 18.3615 0.986655 18.2769 0.862098C17.4307 -0.258918 15.3153 0.903618 14.5115 3.02109C14.4269 3.22869 14.4269 3.43628 14.5538 3.43628C14.6384 3.43628 14.7653 3.22869 14.8076 3.02109Z",
    fill: "#494855"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6115 29.6748L26.3154 29.8409L25.7654 30.4638L25.85 30.7129L26.273 30.2146V32.7059L26.6115 32.5398V29.6748Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0543 31.0459V33.454L8.80046 33.288V31.212L8.75816 31.1705L8.41969 31.212L8.33508 30.9214H8.80046L9.0543 31.0459Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2934_5856",
    x1: 14.2268,
    y1: 27.6993,
    x2: -1.50493,
    y2: 34.4522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDFDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2934_5856",
    x1: 31.6694,
    y1: 31.9245,
    x2: 13.7078,
    y2: 29.2007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBBBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2934_5856",
    x1: 27.3667,
    y1: 22.1728,
    x2: -6.7256,
    y2: 4.53789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#E9E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2934_5856",
    x1: 13.4531,
    y1: 3.21343,
    x2: 19.7762,
    y2: 14.7259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1665,
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3445,
    stopColor: "#B1D4B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2934_5856",
    x1: 15.5928,
    y1: 20.2744,
    x2: 20.2898,
    y2: 10.8065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2934_5856",
    x1: 17.5749,
    y1: 18.694,
    x2: 23.8247,
    y2: 9.61083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2934_5856",
    x1: 11.3366,
    y1: 12.719,
    x2: 13.4274,
    y2: 12.8945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2C9B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E1D8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS);
export default __webpack_public_path__ + "static/media/s.091cc2685f9d387d8a04486eac84b132.svg";
export { ForwardRef as ReactComponent };